import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInputV2 from "../Select/BaseSelectorReadonlyToInputV2";

class BizLocationSelector extends BaseSelectorReadonlyToInputV2 {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: props.title || 'Local',
      label: 'friendlyName',
      url: 'ton/v1/biz-locations/combobox'
    };
  }


}

BizLocationSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default BizLocationSelector;



// WEBPACK FOOTER //
// ./src/component/BizLocation/BizLocationSelector.js